import dayjs from "dayjs";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { CLOVIS_STANDART_DATE_FORMAT } from "~/config/dayjs";
import { notificationsMap } from "~/config/user/user-notifications/notificationsMap";
import type { UserNotification } from "~/config/user/user-notifications/utils/types";
import { useUser } from "~/config/user/UserProvider";
import { ListItem } from "~/design-system/List";
import { Text } from "~/design-system/Text";
import { ReadNotifWrapper } from "../NotificationsListDesktop";
import { AvatarFromUserId } from "./AvatarFromUserId/AvatarFromUserId";

type NotificationListItemProps = {
  data: UserNotification;
};

const NotificationListItem = (props: NotificationListItemProps) => {
  const { t } = useTranslation();
  const { user } = useUser();

  return (
    <ListItem
      avatar={
        <ReadNotifWrapper
          isRead={props.data.read_at !== null}
          display="flex"
          alignItems="center"
        >
          <AvatarFromUserId size="small" userId={props.data.creator_id} />
        </ReadNotifWrapper>
      }
      title={
        <ReadNotifWrapper isRead={props.data.read_at !== null}>
          <Text size="small" truncate>
            {
              notificationsMap[props.data.type]({ user }, props.data as never)
                .content
            }
          </Text>
        </ReadNotifWrapper>
      }
      subtitle={
        <ReadNotifWrapper isRead={props.data.read_at !== null}>
          <Text size="small">
            {dayjs(props.data.created_at).format(CLOVIS_STANDART_DATE_FORMAT)}
          </Text>
        </ReadNotifWrapper>
      }
    />
  );
};

export { NotificationListItem };
